import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import mapData from './modules/mapData'
import auth from './modules/auth'
import manager from './modules/manager'
import board from './modules/board'
import config from './modules/config'
import utile from './plugins/utile'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    app,
    mapData,
    auth,
    manager,
    board,
    config
  },
  plugins: [utile]
})



// WEBPACK FOOTER //
// ./src/store/index.js